type Props = {
  message: string;
};

export function PdfImportProgress({ message }: Props) {
  return (
    <div className="wb-pdf-import-progress" role="status" aria-live="polite">
      <span className="wb-pdf-import-progress__spinner" aria-hidden />
      {message}
    </div>
  );
}
